var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#5C5C5C"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.71 0H10.034C4.495.007.006 4.585 0 10.235v79.458c.006 5.65 4.495 10.23 10.033 10.236H89.71c5.537-.007 10.025-4.586 10.03-10.236V10.235C99.736 4.585 95.248.007 89.711 0zM10.034 4.526H89.71c3.089.004 5.591 2.558 5.594 5.71v45.496l-20.579-20.33c-.857-.848-2.217-.851-3.078-.009l-29.193 28.56-9.695-10.206c-.817-.856-2.146-.918-3.036-.141L4.436 75.753V10.235c.003-3.152 2.507-5.706 5.597-5.71zM4.436 89.693v-7.976l26.594-23.29 9.762 10.277.004.008.007.005 25.35 26.686h-56.12c-3.09-.003-5.594-2.558-5.597-5.71zm85.275 5.71H72.33l-26.788-28.2 27.636-27.035 22.127 21.863v27.662c-.003 3.152-2.505 5.706-5.594 5.71z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.25 34.584c5.753 0 10.416-4.757 10.416-10.626 0-5.87-4.663-10.627-10.416-10.627-5.752 0-10.416 4.758-10.416 10.627.006 5.866 4.666 10.62 10.416 10.626zm0-16.727c3.303 0 5.98 2.731 5.98 6.1 0 3.37-2.677 6.102-5.98 6.102-3.303 0-5.98-2.732-5.98-6.101.004-3.368 2.68-6.097 5.98-6.101z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.63c2360c730de485faf93d257faf23f5.svg";
export { ForwardRef as ReactComponent };